import { Dialog } from 'primereact/dialog'
import React from 'react'

interface ProductionDrawingSuccessModelPropEntity {
    publishCount: number;
    isOpen: boolean;
    onClose: () => void;
    handleSubmit: () => void;
}

export default function ProductionDrawingSuccessModel({ isOpen, onClose, handleSubmit, publishCount }: ProductionDrawingSuccessModelPropEntity) {
    return (
        <Dialog style={{ width: "520px" }} onHide={onClose} visible={isOpen} resizable={false} draggable={false} closable={false}>
            <div className='d-flex flex-column justify-content-center align-items-center gap-3' style={{ fontSize: "20px", fontWeight: "600" }}>
                <img src='/assets/images/success.svg' style={{ width: "6rem" }} />
                <h3 style={{ fontWeight: "700", textAlign: "center" }}>Production drawing uploaded successfully!</h3>
                <p style={{ fontSize: "15.5px" }} className=' text-center'>Production drawing has been uploaded successfully for a total of {publishCount} solutions.</p>
                <button className='btn btn-primary w-100' onClick={handleSubmit}>OK</button>
            </div>
        </Dialog>
    )
}
